import React from "react";
import { useSelector } from "react-redux";

const HasPermission = ({ permission, children }) => {
  const currentUser = useSelector((state) => state.auth.user);

  // On force en tableau pour supporter string ou array
  const requiredPermissions = Array.isArray(permission)
    ? permission
    : [permission];

  const hasPermission = requiredPermissions.some(
    (p) => currentUser?.roleId?.permissions.includes(p) // attention, selon ta structure : user.permissions[] ou user.roleId.permissions[]
  );

  if (!hasPermission) {
    return null;
  }

  return <>{children}</>;
};

export default HasPermission;
